export default {
  SET_CATEGORY(state, payload) {
    state.category = payload;
  },
  SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload;
  },
};
